import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusProbeAssociationFragment = { readonly __typename?: 'SyncableEpocusProbeAssociation', readonly id: string, readonly deviceSerialNumber: string, readonly performerId: string, readonly performerName: string, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusProbeAssociationPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusProbeAssociationInput;
}>;


export type SyncEpocusProbeAssociationPullQuery = { readonly __typename?: 'Query', readonly pullEpocusProbeAssociation: { readonly __typename?: 'PullEpocusProbeAssociationResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusProbeAssociation', readonly id: string, readonly deviceSerialNumber: string, readonly performerId: string, readonly performerName: string, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusProbeAssociationPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusProbeAssociationInput;
}>;


export type SyncEpocusProbeAssociationPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusProbeAssociation: { readonly __typename?: 'PushEpocusProbeAssociationResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusProbeAssociation', readonly id: string, readonly deviceSerialNumber: string, readonly performerId: string, readonly performerName: string, readonly programId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusProbeAssociationFragmentDoc = gql`
    fragment WholeSyncableEpocusProbeAssociation on SyncableEpocusProbeAssociation {
  id
  deviceSerialNumber
  performerId
  performerName
  programId
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusProbeAssociationPullDocument = gql`
    query SyncEpocusProbeAssociationPull($input: PullEpocusProbeAssociationInput!) {
  pullEpocusProbeAssociation(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusProbeAssociation
    }
  }
}
    ${WholeSyncableEpocusProbeAssociationFragmentDoc}`;

/**
 * __useSyncEpocusProbeAssociationPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusProbeAssociationPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusProbeAssociationPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusProbeAssociationPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusProbeAssociationPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusProbeAssociationPullQuery, SyncEpocusProbeAssociationPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusProbeAssociationPullQuery, SyncEpocusProbeAssociationPullQueryVariables>(SyncEpocusProbeAssociationPullDocument, options);
      }
export function useSyncEpocusProbeAssociationPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusProbeAssociationPullQuery, SyncEpocusProbeAssociationPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusProbeAssociationPullQuery, SyncEpocusProbeAssociationPullQueryVariables>(SyncEpocusProbeAssociationPullDocument, options);
        }
export type SyncEpocusProbeAssociationPullQueryHookResult = ReturnType<typeof useSyncEpocusProbeAssociationPullQuery>;
export type SyncEpocusProbeAssociationPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusProbeAssociationPullLazyQuery>;
export type SyncEpocusProbeAssociationPullQueryResult = Apollo.QueryResult<SyncEpocusProbeAssociationPullQuery, SyncEpocusProbeAssociationPullQueryVariables>;
export const SyncEpocusProbeAssociationPushDocument = gql`
    mutation SyncEpocusProbeAssociationPush($input: PushEpocusProbeAssociationInput!) {
  pushEpocusProbeAssociation(input: $input) {
    rows {
      ...WholeSyncableEpocusProbeAssociation
    }
  }
}
    ${WholeSyncableEpocusProbeAssociationFragmentDoc}`;
export type SyncEpocusProbeAssociationPushMutationFn = Apollo.MutationFunction<SyncEpocusProbeAssociationPushMutation, SyncEpocusProbeAssociationPushMutationVariables>;

/**
 * __useSyncEpocusProbeAssociationPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusProbeAssociationPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusProbeAssociationPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusProbeAssociationPushMutation, { data, loading, error }] = useSyncEpocusProbeAssociationPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusProbeAssociationPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusProbeAssociationPushMutation, SyncEpocusProbeAssociationPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusProbeAssociationPushMutation, SyncEpocusProbeAssociationPushMutationVariables>(SyncEpocusProbeAssociationPushDocument, options);
      }
export type SyncEpocusProbeAssociationPushMutationHookResult = ReturnType<typeof useSyncEpocusProbeAssociationPushMutation>;
export type SyncEpocusProbeAssociationPushMutationResult = Apollo.MutationResult<SyncEpocusProbeAssociationPushMutation>;
export type SyncEpocusProbeAssociationPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusProbeAssociationPushMutation, SyncEpocusProbeAssociationPushMutationVariables>;